import ErrorToast from "../../components/common/toasts/ErrorToast";
import React from "react";
import { Link, Navigate, useParams, useSearchParams } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import AddOrderPage from "./pages/orders/AddOrderPage";
import OrderList from "./OrderList";
import PremiumLayout from "./components/PremiumLayout";
import PremiumBackLink from "./components/PremiumBackLink";
import PremiumTabs from "./components/PremiumTabs";
import CompanyList from "./components/CompanyList";
import Dictionaries from "./Dictionaries";
import PremiumNotice from "./components/PremiumNotice";

import usePremiumResource from "./hooks/usePremiumResource";
import { premiumPaths } from "./navigation";

export default function Premium({ section = "orders", action = "list" }) {
  const { accessToken, checkPermission } = useAuth();
  const { companyId } = useParams();
  const [params] = useSearchParams();
  const { data, error, loading, reload } = usePremiumResource(
    accessToken,
    companyId ? `/organizations/${companyId}` : null,
  );
  const organization = data?.organization;
  const admin = checkPermission("Zarządzanie użytkownikami");
  if (!companyId && params.get("company"))
    return <Navigate to={premiumPaths.orders(params.get("company"))} replace />;
  if (!companyId && admin)
    return (
      <Navigate
        to={{ pathname: premiumPaths.admin, search: params.toString() }}
        replace
      />
    );
  const listPath = admin ? premiumPaths.admin : premiumPaths.companies;
  const companySection = companyId && section !== "new" && action === "list";
  return (
    <PremiumLayout
      title={
        section === "new"
          ? "Nowe świadectwo"
          : companyId
            ? organization?.name || "Firma Premium"
            : "Konto Premium"
      }
      subtitle={section === "new" ? organization?.name : undefined}
      actions={
        companySection && (
          <>
            <PremiumBackLink to={listPath} destination="Lista firm" />
            {section === "orders" && organization?.active && (
              <Link
                className="btn btn-primary"
                to={premiumPaths.newOrder(companyId)}
              >
                Nowe świadectwo
              </Link>
            )}
          </>
        )
      }
    >
      <ErrorToast message={error} />
      {loading && <p role="status">Ładowanie firmy…</p>}
      {error && (
        <div className="premium-button-group">
          {!companySection && (
            <PremiumBackLink to={listPath} destination="Lista firm" />
          )}
          <button className="btn btn-outline-primary" onClick={reload}>
            Ponów odczyt
          </button>
        </div>
      )}
      {!companyId && (
        <CompanyList token={accessToken} autoSelect={section !== "companies"} />
      )}
      {organization && (
        <>
          {!organization.active && (
            <PremiumNotice warning>
              Firma jest nieaktywna. Nie można dodawać nowych świadectw.
            </PremiumNotice>
          )}
          {companySection && (
            <PremiumTabs
              company={organization}
              admin={admin}
              adminDictionaries={admin && section !== "dictionaries"}
            />
          )}
          {section === "orders" && (
            <OrderList
              key={companyId}
              organization={organization}
              token={accessToken}
            />
          )}
          {section === "dictionaries" && (
            <Dictionaries
              key={companyId}
              organization={organization}
              token={accessToken}
              action={action}
            />
          )}
          {section === "new" && (
            <AddOrderPage
              key={companyId}
              organization={organization}
              token={accessToken}
            />
          )}
        </>
      )}
    </PremiumLayout>
  );
}
